import { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getTemplates, addTemplate, editTemplate } from '../../actions/other/templatesActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import TemplateForm from '../../components/forms/TemplateForm'

export default function Templates() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {template, templates, resulttemplate, loading, total} = useSelector(state=>state.templates)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getTemplates(page, limit, search))
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getTemplates(page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({})
        setModalShow(true)
    }

    const selectTemplate = (template) => {
        setFormState({...template})
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editTemplate(formState, formState._id))
        }else{
            dispatch(addTemplate(formState))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resulttemplate){
            let resulttemplatenow = resulttemplate
            dispatch({ type: 'TEMPLATE_RESET_RESULT' })
            switch (resulttemplatenow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.template.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.template.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.template.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resulttemplate])

    const columnsTemplate = [
        {
            name: t('admin.template.name'),
            cell: template =>
                <div className='cursor' onClick={() => selectTemplate(template)}>
                    {template.name}
                </div>,
            selector: (template) => template.name,
            sortable: true,
        },{
            name: '',
            width: '100px',
            cell: template =>
                <div className='cursor' onClick={() => selectTemplate(template)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.template.templates')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.template.createtemplate')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {templates?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsTemplate}
                                                data={templates}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.template.thereisnottemplate')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.template.template')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TemplateForm
                        state={formState}
                        templatetype={'admin'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}